module.exports = __webpack_public_path__ + "static/media/Comment_toxicity.9e5d9db2.png";